import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { humanize, titleize, unescapeHTML } from 'underscore.string';
import LocationAutosuggest from 'components/site/location-autosuggest';
import ErrorAlert from 'components/ui/ErrorAlert';
import CustomerSearch from 'components/site/customer-search';
import { withTranslation } from 'react-i18next';
import { sluggify } from 'utils/localization/utils';
class LocationPairForm extends Component {
    constructor(props) {
        super(props);
        this.handleShipperFieldChange = () => {
            this.setState({
                shipper: {
                    company_name: '',
                    _id: null,
                },
            });
        };
        this.handleShipperSelect = (item, value) => {
            this.setState({
                shipper: {
                    company_name: value.name,
                    _id: value._id,
                },
            });
        };
        this.handleCancel = () => this.props.onCancel();
        this.handleSave = (e) => {
            e.preventDefault();
            const error = this.validate();
            if (Object.keys(error).length === 0) {
                const payload = transformPayload(this.state);
                this.props.onSave(payload);
            }
        };
        this.handleAddressSelect = (field) => (item) => this.setState({
            [field]: item,
        });
        this.handleFieldChange = (field) => (e) => this.setState({ [field]: e.target.value });
        this.validate = () => {
            const error = {};
            const { t } = this.props;
            const { origin_name, origin_location, destination_name, destination_location, shipper, } = this.state;
            if (!origin_name || origin_name.trim().length === 0) {
                error.origin_name = t('ORIGIN_NAME_REQUIRED');
            }
            if (!(origin_location === null || origin_location === void 0 ? void 0 : origin_location.address) || origin_location.address.trim() === 0) {
                error.origin_location = t('ORIGIN_ADDRESS_REQUIRED');
            }
            if (!destination_name || destination_name.trim().length === 0) {
                error.destination_name = t('DESTINATION_NAME_REQUIRED');
            }
            if (!(destination_location === null || destination_location === void 0 ? void 0 : destination_location.address) ||
                destination_location.address.trim() === 0) {
                error.destination_location = t('DESTINATION_ADDRESS_REQUIRED');
            }
            if (!shipper._id) {
                error.shipper = t('SHIPPER_IS_REQUIRED');
            }
            this.setState({
                error,
            });
            return error;
        };
        this.state = Object.assign(Object.assign({}, getStateFromProps(props)), { error: {} });
    }
    fieldHasError(field) {
        return this.state.error.hasOwnProperty(field);
    }
    renderValidationErrors() {
        const { t } = this.props;
        const errorKeys = Object.keys(this.state.error);
        if (errorKeys.length === 0) {
            return null;
        }
        return (React.createElement("div", { className: "w-1/2" },
            React.createElement(ErrorAlert, { title: t('MISSING_FIELDS') },
                React.createElement("ul", null, errorKeys.map((key) => (React.createElement("li", { key: key }, this.state.error[key])))))));
    }
    renderShipperField() {
        const { t } = this.props;
        const shipperClassName = classnames({
            'md:mr-2': true,
            error: this.fieldHasError('shipper'),
        });
        return (React.createElement("fieldset", { className: shipperClassName },
            React.createElement("label", { className: "mb-2 form-label" }, titleize(t('SHIPPER', { count: 1 }))),
            React.createElement("div", { className: "customer-search mb-4" },
                React.createElement(CustomerSearch, { clearOnSelect: true, onChange: this.handleShipperFieldChange, onSelect: this.handleShipperSelect, placeholder: t('SEARCH_FOR_SHIPPER'), defaultValue: unescapeHTML(this.state.shipper.company_name), type: "shippers" }))));
    }
    renderNameField(field) {
        const { t } = this.props;
        const fieldClassName = classnames({
            'md:mr-2': true,
            error: this.fieldHasError(field),
        });
        const label = titleize(humanize(field));
        return (React.createElement("fieldset", { className: fieldClassName },
            React.createElement("label", { className: "form-label mb-2 block" }, t(sluggify(label))),
            React.createElement("input", { type: "text", className: "form-field mb-4 w-full", value: this.state[field], placeholder: t(sluggify(label)), onChange: this.handleFieldChange(field) })));
    }
    renderAddressField(field) {
        var _a;
        const { t } = this.props;
        const fieldClassName = classnames({
            error: this.fieldHasError(field),
        });
        const label = titleize(humanize(field));
        return (React.createElement("fieldset", { className: fieldClassName },
            React.createElement("label", { className: "form-label mb-2 block" }, t(sluggify(label))),
            React.createElement("div", { className: "mb-4" },
                React.createElement(LocationAutosuggest, { value: ((_a = this.state[field]) === null || _a === void 0 ? void 0 : _a.address) || null, searchField: "address", callbackSelectedItem: this.handleAddressSelect(field), placeholderText: t('SEARCH_FOR_LOCATION') }))));
    }
    render() {
        const { t } = this.props;
        return (React.createElement("div", { className: "" },
            React.createElement("div", { className: "flex flex-wrap" },
                React.createElement("div", { className: "md:w-1/2" }, this.renderNameField('origin_name')),
                React.createElement("div", { className: "md:w-1/2" }, this.renderAddressField('origin_location'))),
            React.createElement("hr", null),
            React.createElement("div", { className: "flex flex-wrap" },
                React.createElement("div", { className: "md:w-1/2" }, this.renderNameField('destination_name')),
                React.createElement("div", { className: "md:w-1/2" }, this.renderAddressField('destination_location'))),
            React.createElement("div", { className: "flex flex-wrap" },
                React.createElement("div", { className: "md:w-1/2" }, this.renderShipperField())),
            this.renderValidationErrors(),
            React.createElement("div", { className: "form-actions flex justify-end items-center" },
                React.createElement("button", { className: "button button-green", onClick: this.handleSave }, titleize(t('SAVE'))),
                React.createElement("button", { className: "button button-secondary", onClick: this.handleCancel }, titleize(t('CANCEL'))))));
    }
}
LocationPairForm.propTypes = {
    onCancel: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    locationPair: PropTypes.shape({
        origin_name: PropTypes.string,
        origin_location: PropTypes.object,
        destination_name: PropTypes.string,
        destination_location: PropTypes.object,
        shipper: PropTypes.object,
    }),
};
function transformPayload(state) {
    const { origin_location, origin_name, destination_location, destination_name, _id, shipper: { _id: shipperId }, } = state;
    return {
        origin: {
            name: origin_name.trim(),
            address: origin_location.address.trim(),
            place_id: origin_location.place_id,
        },
        destination: {
            name: destination_name.trim(),
            address: destination_location.address.trim(),
            place_id: destination_location.place_id,
        },
        shipper: shipperId,
        _id,
    };
}
function getInitialState() {
    return {
        origin_name: '',
        origin_location: {
            address: '',
        },
        destination_name: '',
        destination_location: {
            address: '',
        },
        shipper: {
            name: '',
            _id: null,
        },
    };
}
function getStateFromProps(props) {
    return props.locationPair || getInitialState();
}
export default withTranslation()(LocationPairForm);
